<img
  src="assets/images/y42-logos/logo.gif"
  [ngStyle]="{ width: widthInPixel + 'px', height: widthInPixel + 'px' }"
  data-test="logo-loader-img"
/>
